import React, { useState} from 'react';
import TextInput from 'web/components/form-elements/TextInput';
import { checkIsZipCode } from 'redux/actions/adminPtPlus/index';
import { useHistory } from 'react-router-dom';
import { useDispatch } from "react-redux";
import NumberInput from 'web/components/form-elements/NumberInput';
import AlertModal from "web/components/AlertModal";
import states from 'states-us';
import styled from 'styled-components';

const AddressEdit = ({ props, response, headingType }) => {    
    const {setFieldValue} = props    
    const dispatch = useDispatch();
    let history = useHistory();
    const territoryStates = states.filter((x) => x.contiguous);
    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState("");
    const [modalLink, setModalLink] = useState("/");
    let title = "";
    const toggleModal = () => setModal(!modal);

    let stateArr = []
    for (let i = 0; i < territoryStates.length; i++) {
        if(territoryStates[i].name !=='District Of Columbia'){
            let obj = {
                value: territoryStates[i].name,
                label: `${territoryStates[i].abbreviation}-${territoryStates[i].name}`,
                isoCode: territoryStates[i].abbreviation
            }
            stateArr.push(obj)
        }
    }

    const callFunction = async(value,setFieldValue)=>{
        const token = localStorage.getItem('token')     
        let response = '';
        if (value.length === 5) {
            response = await dispatch(checkIsZipCode(value, token))
            if (response.success) {               
              setFieldValue('city',response?.data?.city)
              setFieldValue('zip',response?.data?.zipCode)
              setFieldValue('state',response?.data?.state)
               
            } else {
                if (response?.data?.error?.message === 'Invalid Zip Code.') {
                  setFieldValue('city',"")
                  setFieldValue('zip',"")
                  setModalContent("Invalid Zip Code.")
                  toggleModal()  
              setModalLink("");   
                  setFieldValue('state',"")
                          
                } else if (response?.error?.message === "Invalid Token" || response?.message === 'Request failed with status code 401') {
                    history.push('/sign-in')
                    window.location.reload(false);
                } else {
    
                }
            }
        } else {
            setFieldValue('city',"")                 
            setFieldValue('state',"")
            // setFieldValue('locationST',"")
            // setFieldValue('locationCity',"")        
        }
      }

    return (
        <>
            <AddressWrapper>
                <HeadingWrapper className="mt-3">
                    <p className={headingType === 'bold' ? 'bold-p-tag' : 'normal-p-tag'}>
                        {response?.postType === 'NEED' ? 'Pick Up Address' : 'Delivery Address'}
                        <span className="star">*</span>
                    </p>
                </HeadingWrapper>
                <hr />
                <div className="row" style={{ 'margin-top': '-10px' }}>
                    <div className="col-sm-12 form-group">
                        <div className="mt-0">
                            <p>
                                Company Name
                            </p>
                        </div>
                        <TextInput
                            name="name"
                            placeholder="Enter Name*"
                            showErrorMessages={true}
                        />
                    </div>
                </div>
                <div className="row" style={{ 'margin-top': '-30px' }}>
                    <div className="col-sm-6 col-md-6 form-group">
                        <div className="mt-0">
                            <p>
                                Address Line 1
                            </p>
                        </div>
                        <TextInput
                            name="line1"
                            placeholder="Street Address 1*"
                            showErrorMessages={true}
                        />
                    </div>
                    <div className="col-sm-6 col-md-6 form-group mobileRes">
                        <div className="mt-0">
                            <p>
                                Address Line 2
                            </p>
                        </div>
                        <TextInput
                            name="line2"
                            placeholder={"Street Address 2"}
                            showErrorMessages={true}
                        />
                    </div>

                </div>
                <div className="row" style={{ 'margin-top': '-30px' }}>
                    <div className="col-sm-6 col-md-4 form-group">
                        <div className="mt-0">
                            <p>
                                City
                            </p>
                        </div>
                        <TextInput
                            name="city"
                            placeholder="City&#42;"
                        />
                    </div>
                    <div className="col-sm-6 col-md-4 form-group mobileRes">
                        <div className="mt-0">
                            <p>
                                State
                           </p>
                        </div>
                        <TextInput name="state" disabled={true} />
                     
                    </div>
                    <div className="col-sm-6 col-md-4 form-group mobileResponsive">
                        <div className="mt-0">
                            <p>
                                Zip
                            </p>
                        </div>
                        
                        <NumberInput name="zip"
                          placeholder="Zip*"
                          maxLength="5" 
                          onChangeHandler={(value)=>{                  
                            callFunction(value,setFieldValue)                           
                          }}
                        />
                    </div>
                </div>
            </AddressWrapper>
            <AlertModal
                isOpen={modal}
                toggle={toggleModal}
                title={title}
                content={modalContent}
                link={modalLink}
            />
        </>
    )
}


export default AddressEdit;

const AddressWrapper = styled.div`
    border-radius: 10px;
        box-shadow: 0 2px 10px 0 rgb(0 0 0 / 16%);
        padding: 2px 13px 0px 13px;

        hr {
            margin-top: 5px !important;
            margin-bottom: 19px !important;
        }
        @media (max-width: 767px) {
            .mobileResponsive{
                margin-top: -30px;
            }
        }
        @media (max-width: 570px) {
            .mobileRes{
                margin-top: -30px;
            }
        }
    `;

const HeadingWrapper = styled.div`
    position: relative;
    .right-arrow {
        position: absolute;
        left: -33px;
        top: 0;
    }
    .bold-p-tag {
        font-family: 'latobold';
        font-size: 20px;
        color: #000000;
    }
    .normal-p-tag {
        font-family: 'latomedium';
        font-size: 17px;
    }
    display: flex;
    align-items: baseline;
    @media (max-width: 767px) {
        h6 {
        font-size: 20px !important;
        line-height: 36px !important;
        }
        .right-arrow {
        max-width: 71px;
        }
        .mobileResponsive{
            margin-top: -30px;
        }
    }
    `;